import { faEnvelope, faMobile } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { Helmet } from 'react-helmet'
import splash from '../../../media/classroomSplash.jpg'
import { ReactComponent as QuoteIcon } from '../../../media/icon-science.svg'
import oftmcssLogo from '../../../media/oftmcss.svg'
import { Brand, Content, Templates } from 'ui'
import { randomTestimonial } from '../testimonials'

/**
 * A confirmation displayed upon completing the signup process.
 */
export const ConfirmationView: React.FC = () => {
  const testimonial = randomTestimonial()
  return (
    <Templates.SplashImageView
      backgroundImageSrc={splash}
      footerImageSrc={oftmcssLogo}
      splashContent={
        <Templates.SplashQuote
          quote={testimonial.quote}
          author={testimonial.author}
          title={testimonial.title}
          icon={
            <QuoteIcon
              style={{
                width: 'auto',
                height: '60px',
                display: 'block',
              }}
              className="fill-current text-white"
            />
          }
        />
      }
    >
      <Helmet>
        <title>Account Created! - MCSS PRO Connect</title>
      </Helmet>
      <Content.Region>
        <Brand.EpcLogo />
        <Content.Heading>Thank you!</Content.Heading>
        <Content.Body>
          The Office of the Maricopa County School Superintendent is committed
          to ensuring the best possible experience for educators and industry
          professionals alike. An administrator will review your account
          shortly, and will contact you with next steps at the email address
          provided.
        </Content.Body>
        <Content.SubHeading>Questions?</Content.SubHeading>
        <Content.Body>Don’t hesitate to get in touch:</Content.Body>
        <Content.List>
          <Content.ListItem>
            <Content.ListIcon>
              <FontAwesomeIcon icon={faMobile} />
            </Content.ListIcon>
            <Content.Href href="tel:6025063866">(602) 506-3866</Content.Href>
          </Content.ListItem>
          <Content.ListItem>
            <Content.ListIcon>
              <FontAwesomeIcon icon={faEnvelope} />
            </Content.ListIcon>
            <Content.Href href="mailto:stempro@maricopa.gov">
              stempro@maricopa.gov
            </Content.Href>
          </Content.ListItem>
        </Content.List>
      </Content.Region>
    </Templates.SplashImageView>
  )
}
